module.exports = __webpack_public_path__ + "static/media/business-processes-2.b2ce8c2f.jpg";